import { gql, NetworkStatus, useQuery } from '@apollo/client';
import type { QueryHookResult } from '../../../../common/types';

const AUTHENTICATE_USER = gql`
  query Authenticate($code: String!) {
    authenticate(code: $code) {
      success
      message
      token
      errorMessage
    }
  }
`;

interface Authenticate {
  success: boolean;
  message: string;
  token: string;
  errorMessage: string;
}

export interface AuthenticateData {
  authenticate: Authenticate;
}

interface AuthenticateVars {
  code: string;
}

export default function useAuthenticateQuery(
  code: string,
): QueryHookResult<AuthenticateData> {
  const { loading, error, data, networkStatus } = useQuery<
    AuthenticateData,
    AuthenticateVars
  >(AUTHENTICATE_USER, {
    variables: {
      code: code || '',
    },
  });

  return {
    loading,
    error,
    data,
    refetching: networkStatus === NetworkStatus.refetch,
  };
}
